export default __webpack_public_path__ + "static/media/cart-successful.d93a7522.jpg";